/**
 * i18next configuration.
 *
 * Norwegian is the default locale; English is the fallback. New strings
 * MUST be added to BOTH locale files. The `LanguageDetector` checks
 * localStorage first, then the browser's preferred language.
 */

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import no from "./locales/no.json";

export const supportedLanguages = ["no", "en"] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      no: { translation: no },
    },
    fallbackLng: "en",
    supportedLngs: supportedLanguages as unknown as string[],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "vegr.lang",
    },
  });

export default i18n;
